import { v4 } from "uuid";

export const getUniqueId = () => v4();
